import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, Lock, ShieldCheck } from 'lucide-react';

export const PaymentPolicy = () => {
  return (
    <div className="min-h-screen py-16 bg-[#F9F8F6]" data-testid="payment-policy-page">
      <div className="container-custom max-w-4xl">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4" data-testid="payment-title">Payment Policy</h1>
          <p className="text-lg text-softgrey">Secure and convenient payment options.</p>
        </div>

        <div className="space-y-10">
          <section className="bg-cream p-8 rounded-xl" data-testid="accepted-payments-section">
            <div className="flex items-center gap-3 mb-4">
              <CreditCard className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Accepted Payment Methods</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
              <div className="bg-white px-4 py-3 rounded-lg text-center font-semibold text-sm border border-border" data-testid="payment-visa">Visa</div>
              <div className="bg-white px-4 py-3 rounded-lg text-center font-semibold text-sm border border-border" data-testid="payment-mastercard">Mastercard</div>
              <div className="bg-white px-4 py-3 rounded-lg text-center font-semibold text-sm border border-border" data-testid="payment-applepay">Apple Pay</div>
              <div className="bg-white px-4 py-3 rounded-lg text-center font-semibold text-sm border border-border" data-testid="payment-googlepay">Google Pay</div>
            </div>
          </section>

          <section data-testid="security-section">
            <div className="flex items-center gap-3 mb-4">
              <Lock className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Security</h2>
            </div>
            <p className="text-softgrey leading-relaxed">Secure payments only. All transactions are processed through encrypted, PCI-compliant payment gateways. We do not store your payment card details on our servers.</p>
          </section>

          <section data-testid="compliance-section">
            <div className="flex items-center gap-3 mb-4">
              <ShieldCheck className="w-6 h-6 text-coral" />
              <h2 className="text-2xl font-heading font-bold">Your Protection</h2>
            </div>
            <ul className="list-disc list-inside space-y-2 text-softgrey ml-2">
              <li>SSL encrypted checkout</li>
              <li>PCI DSS compliant</li>
              <li>No card details stored on our servers</li>
            </ul>
          </section>
        </div>

        <div className="mt-16 border-t border-border pt-8">
          <p className="text-softgrey text-sm">Payment issues? <Link to="/contact" className="text-coral hover:underline font-semibold">Contact Us</Link> and we'll help resolve them.</p>
        </div>
      </div>
    </div>
  );
};
